import SaveResponsablev2 from "../../shared/components/SaveResponsable/SaveResponsable";

export interface CreateResponsablev2Interface {}

const CreateResponsablev2Page: React.FC<CreateResponsablev2Interface> = () => {
  return <SaveResponsablev2 titlePage="CREAR RESPONSABLE" />;
};

export default CreateResponsablev2Page;